const isNullOrWhiteSpace = (input) => {
  if (typeof input === 'undefined' || input == null) return true;
  return input.replace(/\s/g, '').length < 1;
};

// eslint-disable-next-line import/prefer-default-export
export { isNullOrWhiteSpace };
